import React, { useEffect, useState, Fragment } from 'react'
import { Card, Col, Container, Form, Modal, Row, Button, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { Auth, LoadingComponent } from 'recupero-comunes'
import 'recupero-comunes/dist/index.css'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'
import { makeStyles } from '@material-ui/core/styles';
import Acciones from './aciones'
import { configuracionFormAction38, obtenerDatosGestionImplicado, obtenerDatosGestionImplicadoDefault, actualizarGestionDefensa, obtenerListaImplicados, obtenerDatosLlaves, obtenerComboResponsabilidadAsegurado } from '../../../store/actions/gestion-defensa-action'
import { cambiarLoading, configuracionFormAction15, configuracionFormAction42, obtenerComboModoContactoModal, obtenerComboRespuestaContactoModal, obtenerDatosUltimoContacto, obtenerGrillaHistorial } from '../../../store/actions/modal-contacto-tercero-action'
import { cambiarLoadingGastos, configuracionFormAction22, obtenerComboCobertura, obtenerComboMonedas, obtenerComboTipoGasto, obtenerMontos } from '../../../store/actions/modal-gastos-honorarios-action'
import { useLocation, useNavigate } from 'react-router-dom'

import SpeedDial from '@material-ui/lab/SpeedDial';
import SpeedDialAction from '@material-ui/lab/SpeedDialAction';
import ContactoTerceroModal from './modalContactoTercero'
import ContactoAseguradoModal from './modalContactoAsegurado'
import { MdAccountBox, MdPeopleAlt, MdMonetizationOn, MdAccountBalance, MdLock } from "react-icons/md";
import { ImFileText } from "react-icons/im";
import { FaClipboardList } from "react-icons/fa";
import { BsFileEarmarkMedicalFill } from "react-icons/bs";
import { GiMoneyStack } from "react-icons/gi";

import { AiOutlineMenuUnfold } from "react-icons/ai";
import PrevisionesModal from './modalPrevisiones'
import AntecedentesLegalesModal from './modalAntecedentesLegales'
import GastosHonorariosModal from './modalGastosHonorarios'
import { getCasoImplicado } from '../../../api/api-gestion-defensa'
import { serviceGetPretensionesVigentes } from '../../../api/api-cierre-gestion-defenza'
import CierreGestionDefenzaModal from './modalCierreGestionDefenza'
import ModalSolicitudAumentoPago from './modalCierreGestionDefenza/components/modalSolicitudAumentoPago'
import { ConsultaTrazabilidadHitosComponent, SolicitarInformeComponent } from 'defcol-caso-general';
import { serviceGetInformePenal } from '../../../api/api-informe-penal'
import {
    ETIQUETA_ACTUALIZAR_INFORME, ID_TIPO_GESTION_DEFENSA_PENAL, TEXTO_BOTON_ACTUALIZAR_INFORME, TEXTO_BOTON_INFORME_INICIAL, TEXTO_BOTON_REINTENTAR_INFORME
} from './modalInformePenal/constantes'
import Mensajes from '../../mensajes'

const useStyles = makeStyles((theme) => ({
    root: {
        height: 380,
        transform: 'translateZ(0px)',
        flexGrow: 1,
    },
    speedDial: {
        position: 'absolute',
        top: '-200px',
        right: '-60px',
        zIndex: '150',
        /* marginTop: '-250px', */
        /* right: theme.spacing(5), */
    },
    menu: {
        width: '50px',
        height: '50px',
        zIndex: 250
    },
    tooltip: {
        fontSize: '12px',
        backgroundColor: 'black',
        color: 'white'
    }
}));
const useStylesToltip = makeStyles((theme) => ({
    tooltip: {
        fontSize: '12px',
        backgroundColor: 'black',
        color: 'white'
    }
}));

const AdministracionForm = ({ setIsAmbito, isAmbito }) => {
    const data_gestion_defensa = useSelector((state) => state.gestionDefensaReducer)
    const { llaves, cfg_form38, datosGestionImplicado, datosGestionImplicadoDefault, respuestaActGestionDefensa, listaImplicados, comboResponsabilidadAsegurado } = data_gestion_defensa

    const [loading, setLoading] = useState(false)
    const { esAbogado, rutUsuario, paisOrganizacion } = Auth.currentUser()
    const classes = useStyles();
    const classesTooltip = useStylesToltip();

    const [showContacto, setShowContacto] = useState(false)
    const [showContactoAsegurado, setShowContactoAsegurado] = useState(false)

    const [open, setOpen] = React.useState(false);
    const [hidden, setHidden] = React.useState(false);

    const [ambitoG, setAmbitoG] = useState("")
    const { state } = useLocation()
    const ambitoState = state?.row?.codAmbitoGestion ? state.row.codAmbitoGestion : 232002
    const dispatch = useDispatch()

    const [idCarpetaResExt, setIdCarpetaResExt] = useState('')
    const [fechaAudiencia, setFechaAudiencia] = useState("")
    const [showToast, setShowToast] = useState(true);

    const [implicadoSeleccionado, setImplicadoSeleccionado] = useState('')
    const queryState = JSON.parse(localStorage.getItem('filtrosRecuperoDirecto'))

    const [showModal, setShowModal] = useState(false);

    const [stateResponsabilidadAsegurado, setStateResponsabilidadAsegurado] = useState("");

    // Modal Provisiones
    const [showPrevisiones, setShowPrevisiones] = useState(false);
    const [showImplicadosPrev, setShowImplicadosPrev] = useState(false);
    const [inprocess, setInprocess] = useState(false);
    const [implSeleccionado, setImplSeleccionado] = useState("");
    const [showImplicadosHistorialPrev, setShowImplicadosHistorialPrev] = useState(false);
    const handleClosePrevisiones = () => {
        setShowPrevisiones(false);
        setShowImplicadosPrev(false);
        setShowImplicadosHistorialPrev(false);
    }
    // Gastos
    const [showGastos, setShowGastos] = useState(false)

    // Antecedentes Legales
    const [showAntecedentes, setShowAntecedentes] = useState(false);
    const handleCloseAntecedentes = () => { setShowAntecedentes(false) };
    //

    // Cierre Gestion Defenza
    const [showCierreGestion, setShowCierreGestion] = useState(false);
    const handleCloseCierreGestion = () => { setShowCierreGestion(false) };
    
    // Trazabildiad de Hitos
    const [showTrazabilidadHitos, setShowTrazabilidadHitos] = useState(false);
    
    // Solicitud Informe Profesional
    const [showInformeProfesional, setShowInformeProfesional] = useState(false)

    // Informe de Defensa Penal (RG-576): solo casos con tipo de gestión Defensa Penal.
    const esDefensaPenal = Number(datosGestionImplicadoDefault?.datosGestionImplicado?.[0]?.codTipoGestion) === ID_TIPO_GESTION_DEFENSA_PENAL
    const [informePenal, setInformePenal] = useState(null)
    const [errorInformePenal, setErrorInformePenal] = useState('')
    // El modal «Informe Inicial / Actualizar Informe» se abre desde la pastilla de este componente; el modal y su lógica viven en aciones.js.
    const [showInformePenal, setShowInformePenal] = useState(false)

    // Solicitar Aumento Monto a Conciliar
    const [showAumentoConciliar, setShowAumentoConciliar] = useState(false);
    const [coberturasAumento, setCoberturasAumento] = useState([]);
    const [involucradoAumento, setInvolucradoAumento] = useState({});

    useEffect(() => {
        setAmbitoG(ambitoState)
    }, [state])
    useEffect(() => {
        setIdCarpetaResExt(
            datosGestionImplicadoDefault && datosGestionImplicadoDefault.datosGestionImplicado[0] &&
                datosGestionImplicadoDefault.datosGestionImplicado[0]['idCarpetaResExt'] !== undefined &&
                datosGestionImplicadoDefault.datosGestionImplicado[0]['idCarpetaResExt'] !== null &&
                datosGestionImplicadoDefault.datosGestionImplicado[0]['idCarpetaResExt'] !== ''
                ? datosGestionImplicadoDefault.datosGestionImplicado[0]['idCarpetaResExt']
                : ''
        )

        setFechaAudiencia(
            datosGestionImplicadoDefault && datosGestionImplicadoDefault.datosGestionImplicado[0] &&
                datosGestionImplicadoDefault.datosGestionImplicado[0]['fecAudienciaFormat'] !== undefined &&
                datosGestionImplicadoDefault.datosGestionImplicado[0]['fecAudienciaFormat'] !== null &&
                datosGestionImplicadoDefault.datosGestionImplicado[0]['fecAudienciaFormat'] !== ''
                ? convertirFecha(datosGestionImplicadoDefault.datosGestionImplicado[0]['fecAudienciaFormat'])
                : ''
        )
        setStateResponsabilidadAsegurado(
            datosGestionImplicadoDefault && datosGestionImplicadoDefault.datosGestionImplicado[0] &&
                datosGestionImplicadoDefault.datosGestionImplicado[0]['GradoRespAsegurado'] !== undefined &&
                datosGestionImplicadoDefault.datosGestionImplicado[0]['GradoRespAsegurado'] !== null &&
                datosGestionImplicadoDefault.datosGestionImplicado[0]['GradoRespAsegurado'] !== ''
                ? datosGestionImplicadoDefault.datosGestionImplicado[0]['GradoRespAsegurado']
                : ''
        )
    }, [datosGestionImplicadoDefault])

    // Pastilla «Informe Inicial» / «Actualizar Informe» (RG-576); solo en casos de Defensa Penal. Abre el informe; el historial se abre
    // desde el pie del propio modal. Sin informe cargado y con error pasa a «Reintentar Informe» y vuelve a pedirlo.
    const nombrePastillaInforme = !informePenal && errorInformePenal
        ? TEXTO_BOTON_REINTENTAR_INFORME
        : (informePenal?.etiquetaAccion === ETIQUETA_ACTUALIZAR_INFORME ? TEXTO_BOTON_ACTUALIZAR_INFORME : TEXTO_BOTON_INFORME_INICIAL)
    const pastillaInformePenal = esDefensaPenal
        ? [{ icon: <BsFileEarmarkMedicalFill size={35} style={{ color: '#00aeab' }} />, name: nombrePastillaInforme, id: '106' }]
        : []

    const actions = [
        ...pastillaInformePenal,
        { icon: <MdLock size={35} style={{ color: '#00aeab' }} />, name: "Cierre Gestion Defensa", id: '103' },
        { icon: <MdMonetizationOn size={35} style={{ color: '#00aeab' }} />, name: 'Solicitar Aumento Monto a Conciliar', id: '105' },
        { icon: <FaClipboardList size={35} style={{ color: '#00aeab' }} />, name: 'Consulta Trazabilidad Hitos', id: '104' },
        { icon: <GiMoneyStack size={35} style={{ color: '#00aeab' }} />, name: "Provisión Gasto-Honorario", id: '102' },
        //{ icon: <MdMonetizationOn size={35} style={{ color: '#00aeab' }} />, name: 'Propuesta Indemnización', id: '100' },
        { icon: <ImFileText size={35} style={{ color: '#00aeab' }} />, name: 'Solicitud Informe Profesional', id: '99' },
        { icon: <MdAccountBalance size={35} style={{ color: '#00aeab' }} />, name: 'Antecedentes Legales', id: '101' },        
        { icon: <MdPeopleAlt size={35} style={{ color: '#00aeab' }} />, name: cfg_form38 ? cfg_form38.cfg_form38['gestiondefensa-menu-lateral-ctotro'] : '', id: '38_9' },
        { icon: <MdAccountBox size={35} style={{ color: '#00aeab' }} />, name: cfg_form38 ? cfg_form38.cfg_form38['gestiondefensa-menu-lateral-ctoaseg'] : '', id: '38_24' }
    ];

    const actionsJudicial = [
        ...pastillaInformePenal,
        { icon: <MdLock size={35} style={{ color: '#00aeab' }} />, name: "Cierre Gestion Defensa", id: '103' },
        { icon: <MdMonetizationOn size={35} style={{ color: '#00aeab' }} />, name: 'Solicitar Aumento Monto a Conciliar', id: '105' },
        { icon: <FaClipboardList size={35} style={{ color: '#00aeab' }} />, name: 'Consulta Trazabilidad Hitos', id: '104' },
        { icon: <GiMoneyStack size={35} style={{ color: '#00aeab' }} />, name: "Provisión Gasto-Honorario", id: '102' },
        //{ icon: <MdMonetizationOn size={35} style={{ color: '#00aeab' }} />, name: 'Propuesta Indemnización', id: '100' },
        { icon: <ImFileText size={35} style={{ color: '#00aeab' }} />, name: 'Solicitud Informe Profesional', id: '99' },
        { icon: <MdAccountBalance size={35} style={{ color: '#00aeab' }} />, name: 'Antecedentes Legales', id: '101' },        
        { icon: <MdPeopleAlt size={35} style={{ color: '#00aeab' }} />, name: cfg_form38 ? cfg_form38.cfg_form38['gestiondefensa-menu-lateral-ctotro'] : '', id: '38_9' },
        { icon: <MdAccountBox size={35} style={{ color: '#00aeab' }} />, name: cfg_form38 ? cfg_form38.cfg_form38['gestiondefensa-menu-lateral-ctoaseg'] : '', id: '38_24' },
    ];

    const handleShowContacto = () => setShowContacto(true)
    const handleCloseContacto = () => setShowContacto(false)
    const handleShowContactoAsegurado = () => setShowContactoAsegurado(true)
    const handleCloseContactoAsegurado = () => setShowContactoAsegurado(false)
    const handleOpen = () => { setOpen(true); };
    const handleClose = () => { setOpen(false); };
    const handleCloseGastos = () => setShowGastos(false)
    const handleShowGastos = () => setShowGastos(true)

    const handleCloseInformeProfesional = () => setShowInformeProfesional(false)
    const handleShowInformeProfesional = () => setShowInformeProfesional(true)

    const convertirFecha = (fecha) => {
        if (fecha !== null && typeof fecha !== undefined) {

            const [dia, mes, ano] = fecha?.split('-')
            const fechaFormat = [ano, mes, dia].join('-')

            return fechaFormat
        } else return null
    }
    useEffect(() => {
        if (llaves && cfg_form38 == null) {
            let query = Buffer.from(JSON.stringify({ "rutcia": llaves && llaves["idOrgCaso"], idform: 38 })).toString('base64')
            dispatch(configuracionFormAction38(query))
                .then(() => {
                    let query = Buffer.from(JSON.stringify({ idOrgCaso: llaves['idOrgCaso'], idCaso: llaves['idCaso'] })).toString('base64')
                    dispatch(obtenerListaImplicados(query))
                }).then(() => {
                    let query = Buffer.from(JSON.stringify({ "idCaso": llaves["idCaso"], "idImplicado": 0 })).toString('base64');
                    dispatch(obtenerDatosGestionImplicadoDefault(query))
                }).then(() => {
                    let query = Buffer.from(JSON.stringify({ concepto: 309 })).toString('base64')
                    dispatch(obtenerComboResponsabilidadAsegurado(query))
                })
        }
    }, [dispatch, llaves, cfg_form38])

    useEffect(() => {
        if (listaImplicados && listaImplicados.listaImplicados && listaImplicados.listaImplicados.length === 1) {          
            let idImplicado = listaImplicados.listaImplicados[0].IdImplicado;
            formik.setFieldValue('implicados', 1);
            setImplicadoSeleccionado(idImplicado)
            let query = { "idCaso": llaves['idCaso'], "idImplicado": idImplicado, "idOrgCaso": llaves['idOrgCaso'], "idUsuario": rutUsuario }
            dispatch(obtenerDatosLlaves(query))
            let query2 = Buffer.from(JSON.stringify({ "idCaso": llaves["idCaso"], "idImplicado": idImplicado })).toString('base64')
            dispatch(obtenerDatosGestionImplicado(query2))
        }    
    }, [listaImplicados])

    // Último informe del caso (modo `ultimo`): define la etiqueta del botón y el modo del formulario. Se pide al montar
    // la pantalla, cuando ya hay llaves y el caso es de Defensa Penal; para Civil no se llama.
    // Devuelve el informe leído (o null si falló) para que quien lo llama sepa si puede abrir el modal.
    const cargarInformePenal = async () => {
        setErrorInformePenal('')
        try {
            const query = Buffer.from(JSON.stringify({ modo: 'ultimo', idCaso: llaves.idCaso })).toString('base64')
            const informe = await serviceGetInformePenal(query)
            setInformePenal(informe)
            return informe
        } catch (error) {
            console.error('Error al obtener el informe de defensa penal:', error.message)
            setInformePenal(null)
            // No es silencioso: aciones.js lo muestra y ofrece reintentar (sin esto el botón quedaría deshabilitado sin explicación).
            setErrorInformePenal(error.message || 'No se pudo obtener el informe de defensa penal.')
            return null
        }
    }

    useEffect(() => {
        if (esDefensaPenal && llaves?.idCaso) cargarInformePenal()
    }, [esDefensaPenal, llaves?.idCaso])

    const handleAction = async (action) => {
        if (action === "38_9") {//Contacto a tercero
            if (!implicadoSeleccionado) {
                setShowModal(true);
            } else {
                handleShowContacto()
                if (llaves && datosGestionImplicado) {
                    dispatch(cambiarLoading(true))
                    let query = Buffer.from(JSON.stringify({
                        rutcia: llaves && llaves['idOrgCaso'],
                        idform: 15
                    })).toString('base64')
                    dispatch(configuracionFormAction15(query))
                        .then(() => {
                            let query = Buffer.from(
                                JSON.stringify({ "idCaso": llaves && llaves["idCaso"], "idImplicado": llaves && llaves["idImplicado"] })
                            ).toString('base64')
                            dispatch(obtenerDatosUltimoContacto(query))
                        })
                        .then(() => {
                            let query = Buffer.from(JSON.stringify({
                                idCaso: llaves && llaves["idCaso"],
                                idImplicado: llaves && llaves["idImplicado"],
                                idModoIngreso1: 238011,
                                idModoIngreso2: 238012,
                                tipoGestion: datosGestionImplicado && datosGestionImplicado.datosGestionImplicado[0]['codTipoGestion'],
                                ambitoGestion: datosGestionImplicado && datosGestionImplicado.datosGestionImplicado[0]['codAmbitoGestion'],
                                responsableReasignado: false
                            })).toString('base64')
                            dispatch(obtenerGrillaHistorial(query))
                        })
                        .then(() => {
                            let query = Buffer.from(JSON.stringify({
                                tipoGestion: datosGestionImplicado && datosGestionImplicado.datosGestionImplicado[0]['codTipoGestion'],
                                ambitoGestion: datosGestionImplicado && datosGestionImplicado.datosGestionImplicado[0]['codAmbitoGestion'],
                                idModoIngreso: 238011
                            })).toString('base64')
                            dispatch(obtenerComboModoContactoModal(query))
                        })
                        .then(() => {
                            let query = Buffer.from(JSON.stringify({
                                tipoGestion: datosGestionImplicado && datosGestionImplicado.datosGestionImplicado[0]['codTipoGestion'],
                                ambitoGestion: datosGestionImplicado && datosGestionImplicado.datosGestionImplicado[0]['codAmbitoGestion'],
                                idModoIngreso: 238012
                            })).toString('base64')
                            dispatch(obtenerComboRespuestaContactoModal(query))
                        })
                        .then(() => dispatch(cambiarLoading(false)))
                }
            }
        } else if (action === "38_24") { //Contacto Asegurado
            handleShowContactoAsegurado()
            if (llaves && datosGestionImplicadoDefault) {
                dispatch(cambiarLoading(true))
                let query = Buffer.from(JSON.stringify({
                    rutcia: llaves && llaves['idOrgCaso'],
                    idform: 42
                })).toString('base64')
                dispatch(configuracionFormAction42(query))
                    .then(() => {
                        let query = Buffer.from(
                            JSON.stringify({
                                "idCaso": llaves && llaves["idCaso"],
                                "idImplicado": 0 //Se obtiene para Asegurado llaves && llaves["idImplicado"] 
                            })).toString('base64')
                        dispatch(obtenerDatosUltimoContacto(query))
                    })
                    .then(() => {
                        let query = Buffer.from(JSON.stringify({
                            idCaso: llaves && llaves["idCaso"],
                            idImplicado: 0, //Se obtiene para Asegurado llaves && llaves["idImplicado"],
                            idModoIngreso1: 238013,
                            //idModoIngreso2: 238003,
                            tipoGestion: datosGestionImplicadoDefault && datosGestionImplicadoDefault.datosGestionImplicado[0]['codTipoGestion'],
                            ambitoGestion: datosGestionImplicadoDefault && datosGestionImplicadoDefault.datosGestionImplicado[0]['codAmbitoGestion'],
                            responsableReasignado: false
                        })).toString('base64')
                        dispatch(obtenerGrillaHistorial(query))
                    })
                    .then(() => {
                        let query = Buffer.from(JSON.stringify({
                            tipoGestion: datosGestionImplicadoDefault && datosGestionImplicadoDefault.datosGestionImplicado[0]['codTipoGestion'],
                            ambitoGestion: datosGestionImplicadoDefault && datosGestionImplicadoDefault.datosGestionImplicado[0]['codAmbitoGestion'],
                            idModoIngreso: 238013
                        })).toString('base64')
                        dispatch(obtenerComboModoContactoModal(query))
                    })
                    .then(() => dispatch(cambiarLoading(false)))
            }
        } else if (action === "100") { // Propuesta Indemnizacion
            if (implicadoSeleccionado) {
                const query = Buffer.from(JSON.stringify({ idCaso: llaves && llaves.idCaso, idImplicado: implicadoSeleccionado })).toString('base64');
                const response = await getCasoImplicado(query);

                if (response && response[0]?.ultimaPropuestaIndeminizacion?.CodMonedaIngreso && response[0]?.ultimaPropuestaIndeminizacion?.CodSituacion === 245002) {
                    setInprocess(false);
                    setShowPrevisiones(true);
                } else if (response && !response[0]?.ultimaPropuestaIndeminizacion?.CodMonedaIngreso && !response[0]?.ultimaPropuestaIndeminizacion?.CodInstancia) {
                    setInprocess(false);
                    setShowPrevisiones(true);
                } else {
                    setInprocess(true);
                    setShowPrevisiones(true);
                    setImplSeleccionado(response && response[0] ? response[0] : {});
                }
            } else {
                setShowModal(true);
            }
        } else if (action === "101") { // Antecedentes Legales
            setShowAntecedentes(true);
        } else if (action === '102') {// Provisión Gasto-Honorario
            if (llaves) {
                dispatch(cambiarLoadingGastos(true))
                let query = Buffer.from(
                    JSON.stringify({ "rutcia": llaves && llaves["idOrgCaso"], idform: 22 })
                ).toString('base64')
                dispatch(configuracionFormAction22(query)).then(setLoading(false))
                    .then(() => {
                        let query = Buffer.from(JSON.stringify({
                            "idImplicado": llaves && llaves['idImplicado'],
                            "idCaso": llaves && llaves['idCaso']
                        })).toString('base64')
                        dispatch(obtenerMontos(query))
                    })
                    .then(() => {
                        let query = Buffer.from(
                            JSON.stringify({
                                "concepto": 244
                            })
                        ).toString('base64')
                        dispatch(obtenerComboTipoGasto(query))
                    })
                    .then(() => {
                        let query = Buffer.from(
                            JSON.stringify({ "pais": paisOrganizacion, 'clasBien': datosGestionImplicadoDefault && datosGestionImplicadoDefault.datosGestionImplicado[0]['codClasCaso'] })
                        ).toString('base64')
                        dispatch(obtenerComboMonedas(query))
                    })
                    .then(() => {
                        let query = Buffer.from(
                            JSON.stringify({
                                "concepto": 214
                            })
                        ).toString('base64')
                        dispatch(obtenerComboCobertura(query))
                    })
                    .then(() => dispatch(cambiarLoadingGastos(false)))
            }
            handleShowGastos()
        } else if (action === "103") { // Cierre Gestion Defenza
            setShowCierreGestion(true);
        } else if (action === "104") { // Trzabilidad Hitos
            setShowTrazabilidadHitos(true);
        } else if (action === "99") { // Informe Profesional
            setShowInformeProfesional(true);
        } else if (action === "105") { // Solicitar Aumento Monto a Conciliar
            if (!implicadoSeleccionado) {
                setShowModal(true);
            } else {
                setLoading(true);
                try {
                    const qImpl = Buffer.from(JSON.stringify({ idCaso: llaves.idCaso, idImplicado: implicadoSeleccionado })).toString('base64');
                    const respImpl = await getCasoImplicado(qImpl);
                    const impl = respImpl?.[0];
                    setInvolucradoAumento({
                        rut      : impl?.RutInvolucrado       || '',
                        nombre   : impl?.NombreInvolucrado    || '',
                        tipo     : impl?.GlosaTipoInvolucrado || '',
                        patente  : impl?.Patente              || '',
                        lesionado: impl?.GlosaImplLesionado   || ''
                    });

                    const tipoGestion = datosGestionImplicado?.datosGestionImplicado?.[0]?.codTipoGestion;
                    const qCob = Buffer.from(JSON.stringify({
                        idCaso        : llaves.idCaso,
                        idImplicado   : implicadoSeleccionado,
                        tipoGestion,
                        tipoMovimiento: 261002
                    })).toString('base64');
                    const respCob = await serviceGetPretensionesVigentes(qCob);
                    setCoberturasAumento(
                        (respCob?.coberturasPoliza || []).filter(c => Number(c.montoAutoConciliar) > 0)
                    );
                } catch (e) {
                    console.error('Error cargando datos aumento conciliar:', e);
                } finally {
                    setLoading(false);
                }
                setShowAumentoConciliar(true);
            }
        } else if (action === "106") { // Informe Inicial / Actualizar Informe (RG-576): relee el último informe y, si pudo, abre el modal
            // Se vuelve a leer al abrir porque lo cargado al montar la pantalla puede estar desfasado (p. ej. un proceso judicial
            // de Fiscalía ingresado después no aparecía en el combo hasta recargar con F5). Mientras carga no hace nada.
            if (informePenal || errorInformePenal) {
                setLoading(true);
                const ultimo = await cargarInformePenal();
                setLoading(false);
                if (ultimo) setShowInformePenal(true);
            }
        } else { console.info("SIN LLAVES....") }
    }
    const recargarImplicados = () => {
        setLoading(true);
        let query = Buffer.from(JSON.stringify({ idOrgCaso: llaves['idOrgCaso'], idCaso: llaves['idCaso'] })).toString('base64')
        dispatch(obtenerListaImplicados(query)).then(() => setLoading(false))
    }
    const handleCloseToast = () => {
        setShowToast(false);
    }

    
    const formik = useFormik({
        initialValues: {
            "idCaso": "",
            "idImplicadoCaso": "",
            "idOrganizacion": "",
            "idCarpetaResExt": "",
            "codTipoGestion": "",
            "codAmbitoGestion": "",
            "glosaAmbitoGestion": "",
            "fechaAudiencia": "",
            "codHitoContacto": "",
            "fechaHitoContacto": "",
            "minutaHitoContacto": "",
            "codHitoRespuesta": "",
            "fechaHitoRespuesta": "",
            "minutaHitoRespuesta": "",
            "recepciona": "",
            "aliasApp": "",
            "idUsuario": "",
            "responsabilidadAsegurado": "",
        },
        //validationSchema: validationSchemas(isRegistraHito),

        onSubmit: (formData) => {
            setLoading(true)
            const dataForm = { ...formData }
            dataForm["idCaso"] = llaves && llaves["idCaso"]
            dataForm["idImplicadoCaso"] = 0 //Se registra para Asegurado (Caso)llaves && llaves["idImplicado"]
            dataForm["idOrganizacion"] = llaves && llaves["idOrgCaso"]
            dataForm["idUsuario"] = llaves && llaves["idUsuario"]
            dataForm["codTipoGestion"] = datosGestionImplicado && datosGestionImplicado.datosGestionImplicado[0]["codTipoGestion"]
            dataForm["codAmbitoGestion"] = datosGestionImplicado && datosGestionImplicado.datosGestionImplicado[0]["codAmbitoGestion"]
            dataForm["aliasApp"] = ""
            dataForm["recepciona"] = 0

            dispatch(actualizarGestionDefensa(dataForm)).then(() => setLoading(false))
        }
    })

    return (
        <>
            <style type='text/css'>
                {`
                .btn-subir {
                    background-color: #00aeab;
                    color: #FFFFFF;   
                    height:40px;
                }
                .btn-subir:hover{
                    background-color:#01cec8;
                    color: #FFFFFF;
                } 
                .cardHeader {
                    background-color: #77789b;
                    color: #FFFFFF;
                }
            `}
            </style>

            <ContactoTerceroModal showContacto={showContacto} handleCloseContacto={handleCloseContacto} />
            <ContactoAseguradoModal showContactoAsegurado={showContactoAsegurado} handleCloseContactoAsegurado={handleCloseContactoAsegurado} />
            <PrevisionesModal
                handleClosePrevisiones={handleClosePrevisiones}
                showPrevisiones={showPrevisiones}

                showImplicados={showImplicadosPrev}
                setShowImplicados={setShowImplicadosPrev}
                showImplicadosHistorial={showImplicadosHistorialPrev}
                setShowImplicadosHistorial={setShowImplicadosHistorialPrev}
                modalAction="tab"
                inprocess={inprocess}
                implSeleccionado={implSeleccionado}
            />

            <AntecedentesLegalesModal
                showAntecedentes={showAntecedentes}
                handleCloseAntecedentes={handleCloseAntecedentes}
            />

            <GastosHonorariosModal showGastos={showGastos} handleCloseGastos={handleCloseGastos} />

            <CierreGestionDefenzaModal
                showCierreGestion={showCierreGestion}
                handleClose={handleCloseCierreGestion}
            />
            <ConsultaTrazabilidadHitosComponent
                idCaso={llaves?.idCaso}
                idOrgCaso={llaves?.idOrgCaso}
                tipoGestion={datosGestionImplicadoDefault?.datosGestionImplicado[0]?.codTipoGestion}
                showModal={showTrazabilidadHitos}
                setShowModal={setShowTrazabilidadHitos}
            />
            <SolicitarInformeComponent
                idCaso={llaves?.idCaso}
                idOrgCaso={llaves?.idOrgCaso}
                showModal={showInformeProfesional}
                setShowModal={setShowInformeProfesional}
            />
            <ModalSolicitudAumentoPago
                show={showAumentoConciliar}
                onHide={() => setShowAumentoConciliar(false)}
                implicado={implicadoSeleccionado}
                involucrado={involucradoAumento}
                coberturas={coberturasAumento}
            />

            <LoadingComponent show={loading} />

            <div className={classes.root}>
                <Form onSubmit={formik.handleSubmit}>

                    <Container className='mb-4 mt-2 position-relative'>
                        <SpeedDial
                            ariaLabel="SpeedDial tooltip example"
                            className={classes.speedDial}
                            hidden={hidden}
                            icon={<AiOutlineMenuUnfold size={30} />}
                            onClose={handleClose}
                            onOpen={handleOpen}
                            open={true}
                        >
                            {ambitoG === 232001 ? (
                                esAbogado ?
                                    actions.map((action) => (
                                        <SpeedDialAction
                                            key={action.id}
                                            icon={action.icon}
                                            tooltipTitle={action.name}
                                            className={classes.menu}
                                            onClick={() => handleAction(action.id)}
                                            TooltipClasses={classesTooltip}
                                        />
                                    )) : actions.filter(f => f.id !== '14_13').map((action) => (
                                        <SpeedDialAction
                                            key={action.id}
                                            icon={action.icon}
                                            tooltipTitle={action.name}
                                            className={classes.menu}
                                            onClick={() => handleAction(action.id)}
                                            TooltipClasses={classesTooltip}
                                        />
                                    ))
                            ) : (
                                esAbogado ?
                                    actionsJudicial.map((action) => (
                                        <SpeedDialAction
                                            key={action.id}
                                            icon={action.icon}
                                            tooltipTitle={action.name}
                                            className={classes.menu}
                                            onClick={() => handleAction(action.id)}
                                            TooltipClasses={classesTooltip}
                                        />
                                    )) :
                                    actionsJudicial.filter(f => f.id !== '14_13').map((action) => (
                                        <SpeedDialAction
                                            key={action.id}
                                            icon={action.icon}
                                            tooltipTitle={action.name}
                                            className={classes.menu}
                                            onClick={() => handleAction(action.id)}
                                            TooltipClasses={classesTooltip}
                                        />
                                    ))
                            )}
                        </SpeedDial>
                   
                        <Card className='mt-1'>
                            <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#D9EDF6', color: '#8578CD' }}>
                                {cfg_form38 ? cfg_form38.cfg_form38['gestiondefensa-subtitle'] : 'Sin cfg_38'}
                            </Card.Header>

                            <Container>
                                <Container>
                                    {cfg_form38 ? (
                                        <div>
                                            <Row>
                                                <Col md="3">
                                                    <Form.Label className='mb-0 mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                        {cfg_form38.cfg_form38['gestiondefensa-input-carpeta']}
                                                    </Form.Label>{' '}
                                                    <br />
                                                    <Form.Control
                                                        className='mt-2'
                                                        autoComplete='off'
                                                        value={
                                                            (formik.values.idCarpetaResExt =
                                                                idCarpetaResExt !== undefined && idCarpetaResExt)
                                                        }
                                                        onChange={(e) => {
                                                            formik.handleChange(e)
                                                            setIdCarpetaResExt(e.target.value)
                                                        }}
                                                        name='idCarpetaResExt'
                                                        error={formik.errors.idCarpetaResExt}
                                                    ></Form.Control>
                                                </Col>
                                                <Col md="3">
                                                    <Form.Label
                                                        className='mt-3'
                                                        style={{ fontWeight: 'bold', fontSize: '14px' }}
                                                    >
                                                        {
                                                            cfg_form38.cfg_form38[
                                                            'gestiondefensa-lbl-ambito'
                                                            ]
                                                        }
                                                    </Form.Label>
                                                    <br />
                                                    <Form.Text className="mt-5">
                                                        {datosGestionImplicadoDefault && datosGestionImplicadoDefault.datosGestionImplicado[0] &&
                                                            datosGestionImplicadoDefault.datosGestionImplicado[0]['ambitoGestion'] !== undefined &&
                                                            datosGestionImplicadoDefault.datosGestionImplicado[0]['ambitoGestion'] !== null &&
                                                            datosGestionImplicadoDefault.datosGestionImplicado[0]['ambitoGestion'] !== ''
                                                            ? datosGestionImplicadoDefault.datosGestionImplicado[0]['ambitoGestion']
                                                            : ''}
                                                    </Form.Text>
                                                </Col>
                                                <Col md="3">
                                                    <Form.Label
                                                        className='mt-3'
                                                        style={{ fontWeight: 'bold', fontSize: '14px' }}
                                                    >
                                                        {cfg_form38.cfg_form38['gestiondefensa-lbl-fecaudiencia']}
                                                    </Form.Label>
                                                    <br />
                                                    <Form.Text className="mt-5">
                                                        {datosGestionImplicadoDefault && datosGestionImplicadoDefault.datosGestionImplicado[0] &&
                                                            datosGestionImplicadoDefault.datosGestionImplicado[0]['fecAudienciaFormat'] !== undefined &&
                                                            datosGestionImplicadoDefault.datosGestionImplicado[0]['fecAudienciaFormat'] !== null &&
                                                            datosGestionImplicadoDefault.datosGestionImplicado[0]['fecAudienciaFormat'] !== ''
                                                            ? datosGestionImplicadoDefault.datosGestionImplicado[0]['fecAudienciaFormat']
                                                            : ''}
                                                    </Form.Text>
                                                </Col>
                                                <Col md='3'>
                                                    <Form.Label className='mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                        {cfg_form38 && cfg_form38.cfg_form38['modalprovippta-cmb-reasp-asegurado'] ? cfg_form38.cfg_form38['modalprovippta-cmb-reasp-asegurado'] : 'Responsabilidad Asegurado'}
                                                    </Form.Label>
                                                    <br />
                                                    <Form.Text className="mt-2" style={{ display: 'block' }}>
                                                        {comboResponsabilidadAsegurado?.comboResponsabilidadAsegurado?.find(c => String(c.id) === String(stateResponsabilidadAsegurado))?.nombre || ''}
                                                    </Form.Text>
                                                </Col>
                                            </Row>
                                            <hr style={{ color: '#04005D', height: '2px', marginTop: '30px' }}></hr>
                                        </div>
                                    ) : null}
                                </Container>
                            </Container>

                            <Container>
                                <Container>
                                    {cfg_form38 ? (
                                        <div>
                                            <Row>
                                                <Col md="5">
                                                    <Form.Label className='mb-0 mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                        Seleccione Implicado
                                                    </Form.Label>{' '}
                                                    <br />
                                                    <Form.Select
                                                        className='mt-2'
                                                        name='implicados'
                                                        onChange={(e) => {
                                                            formik.handleChange(e);
                                                            setImplicadoSeleccionado(e.target.value)
                                                            let impl = e.target.value !== "" ? e.target.value : 0;

                                                            let query = { "idCaso": llaves['idCaso'], "idImplicado": impl, "idOrgCaso": llaves['idOrgCaso'], "idUsuario": rutUsuario }
                                                            dispatch(obtenerDatosLlaves(query))
                                                            let query2 = Buffer.from(JSON.stringify({ "idCaso": llaves["idCaso"], "idImplicado": impl })).toString('base64')
                                                            dispatch(obtenerDatosGestionImplicado(query2))

                                                            /*if (e.target.value !== "") {
                                                                let query = {
                                                                    "idCaso": llaves['idCaso'], "idImplicado": e.target.value, "idOrgCaso": llaves['idOrgCaso'], "idUsuario": rutUsuario
                                                                }
                                                                dispatch(obtenerDatosLlaves(query))
                                                                let query2 = Buffer.from(JSON.stringify({ "idCaso": llaves["idCaso"], "idImplicado": e.target.value })).toString('base64')
                                                                dispatch(obtenerDatosGestionImplicado(query2))
                                                            } else {
                                                                let query = {"idCaso": llaves['idCaso'], "idImplicado": 0, "idOrgCaso": llaves['idOrgCaso'], "idUsuario": rutUsuario}
                                                                dispatch(obtenerDatosLlaves(query))
                                                            }*/
                                                        }}
                                                        value={formik.values.implicados}
                                                    >
                                                        <option value={''}>Seleccione...</option>
                                                        {listaImplicados &&
                                                            listaImplicados.listaImplicados?.map((c) => (
                                                                <option key={c.IdImplicado} value={c.IdImplicado}>{c.NombreImplicadoCmb}</option>
                                                            ))}
                                                    </Form.Select>
                                                </Col>
                                                <Col md="1">
                                                    <Form.Label className='mb-0 mt-4' style={{ fontWeight: 'bold', fontSize: '14px', color: 'white' }}>-</Form.Label>{' '}<br />
                                                    <OverlayTrigger overlay={<Tooltip id='tooltip-disabled'>Recargar Implicados </Tooltip>}>
                                                        <Button type="button" style={{ float: 'left', backgroundColor: 'white', color: 'black' }} variant="outline-secondary" size="sm" onClick={() => recargarImplicados()}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-clockwise" viewBox="0 0 16 16">
                                                                <path fillRule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z" />
                                                                <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
                                                            </svg>
                                                        </Button>
                                                    </OverlayTrigger>
                                                </Col>
                                                <Col md="3">
                                                    <Form.Label
                                                        className='mt-3'
                                                        style={{ fontWeight: 'bold', fontSize: '14px' }}
                                                    >
                                                        {
                                                            cfg_form38.cfg_form38[
                                                            'gestiondefensa-lbl-ulthito'
                                                            ]
                                                        }
                                                    </Form.Label>
                                                    <br />
                                                    <Form.Text className="mt-5">
                                                        {datosGestionImplicado && datosGestionImplicado.datosGestionImplicado[0] &&
                                                            datosGestionImplicado.datosGestionImplicado[0]['ultimoHitoCaso'] !== undefined &&
                                                            datosGestionImplicado.datosGestionImplicado[0]['ultimoHitoCaso'] !== null &&
                                                            datosGestionImplicado.datosGestionImplicado[0]['ultimoHitoCaso'] !== ''
                                                            ? datosGestionImplicado.datosGestionImplicado[0]['ultimoHitoCaso']
                                                            : ''}
                                                    </Form.Text>
                                                </Col>
                                                <Col md="3">
                                                    <Form.Label
                                                        className='mt-3'
                                                        style={{ fontWeight: 'bold', fontSize: '14px' }}
                                                    >
                                                        {
                                                            cfg_form38.cfg_form38[
                                                            'gestiondefensa-lbl-fechito'
                                                            ]
                                                        }
                                                    </Form.Label>
                                                    <br />
                                                    <Form.Text className="mt-5">
                                                        {datosGestionImplicado && datosGestionImplicado.datosGestionImplicado[0] &&
                                                            datosGestionImplicado.datosGestionImplicado[0]['fechaUltimoHitoFormat'] !== undefined &&
                                                            datosGestionImplicado.datosGestionImplicado[0]['fechaUltimoHitoFormat'] !== null &&
                                                            datosGestionImplicado.datosGestionImplicado[0]['fechaUltimoHitoFormat'] !== ''
                                                            ? datosGestionImplicado.datosGestionImplicado[0]['fechaUltimoHitoFormat']
                                                            : ''}
                                                    </Form.Text>
                                                </Col>
                                            </Row>
                                            <hr style={{ color: '#04005D', height: '2px', marginTop: '20px', marginBottom: '0' }}></hr>
                                        </div>
                                    ) : null}
                                </Container>
                            </Container>
                            <Container>
                                <Container>
                                    {cfg_form38 && (
                                        <Fragment>
                                            <Row>
                                                <Col md="8"></Col>
                                                <Col >                                                    
                                                    {respuestaActGestionDefensa && 
                                                        <Mensajes
                                                            showToast={showToast}
                                                            handleCloseToast={handleCloseToast}
                                                            delay={5000}
                                                            responseData={respuestaActGestionDefensa?.respuestaActGestionDefensa}
                                                        ></Mensajes>
                                                    }
                                                </Col>
                                            </Row>
                                            <Acciones implicadoSeleccionado={implicadoSeleccionado} informePenal={informePenal} errorInformePenal={errorInformePenal} onInformeRegistrado={cargarInformePenal} showInformePenal={showInformePenal} setShowInformePenal={setShowInformePenal} />
                                        </Fragment>
                                    )}
                                </Container>
                            </Container>
                        </Card>
                    </Container>
                </Form>
            </div>
            <Modal show={showModal} onHide={() => setShowModal(false)} size='md'>
                <Card>
                    <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#4F517A', color: 'white' }}>
                        Información
                    </Card.Header>

                    <Card.Body>
                        Debe seleccionar un Implicado antes de continuar.
                    </Card.Body>

                    <Card.Footer style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button className='m-2 w-auto' variant='outline-info' onClick={() => setShowModal(false)}>Cerrar</Button>
                    </Card.Footer>
                </Card>
            </Modal>
        </>
    )
}

export default AdministracionForm